<template>
  <section class="section-temp">
    <div class="container myprofile mb-4">
      <div class="row overflow-visible">
        <div class="col-12 mt-1 px-0 bg-white">
          <div class="card profile-card first">
            <h5 class="editing-heading text-center">
              {{ cpLang('jd.your_profile') }}
            </h5>
            <h3 class="d-inline-block">
              {{ cpLang('profile.personal_detail') }}
            </h3>
            <div class="row position-relative">
              <div class="col-3 d-none d-sm-block">
                <div class="icon-wrap">
                  <img ref="photo" :src="photoUrl" class="preview-avator">
                </div>
              </div>
              <div class="col-12 col-sm-9">
              <ProfileSummary
                :is-nav-bar="false"
                :member-info="summaryObj"
                :expectation-info="expectation"
                :load-data="showEditButton"
                is-preview-profile
              />
              </div>
            </div>
          </div>
          <!-- end summary card-->
          <!-- experience card -->
          <div class="card profile-card workexp-card-wrap">
            <div class="d-inline">
              <h3 class="d-inline-block">
                {{ cpLang('profile.experience') }}
              </h3>
              <div class="clear-both" />
            </div>
            <div v-for="exp in experiences" :key="exp.id" class="row exp">
              <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                {{ exp.expfrom && exp.expfrom.date ? formatDate(exp.expfrom.date) : '' }}
                <span> - </span>
                <!-- {{ exp.expto ? formatDate(exp.expto.date) : '' }} -->
                {{ exp.ismostrecent === '1' ? 'present' : exp.expto && exp.expto.date ? formatDate(exp.expto.date) : '' }}
              </div>
              <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12">
                <b>{{ exp.jobtitletext }}</b>
                  <span v-show="exp.actualsalary > 0">(THB {{ exp.actualsalary }} {{ exp.salarytype === 0 ? 'Monthly' : exp.salarytype === 1 ? 'Daily' : 'Hourly' }})</span>
                  - {{ exp.companyname }} <span v-if="validObj(exp.location, 'desc') !== ''">, {{ exp.location.desc }}</span>
                <p v-show="checkEmpty(exp.roles) !== ''" class="pt-1 mb-1">
                  <b>{{ cpLang('profile.work_role_text') }} : </b>
                </p>
                <div v-html="displayRoles(exp)" class="text-small" />
                <p v-show="checkEmpty(exp.achievement) !== ''" class="pt-1 mb-1">
                  <b>{{ cpLang('profile.achievement') }} : </b>
                </p>
                <div v-html="displayAchievement(exp)" class="text-small" />
              </div>
            </div>
          </div>
          <!-- end experience card -->
          <!-- edu -->
          <div class="card profile-card edu-card-wrap">
            <div class="d-inline">
              <h3 class="d-inline-block">
                {{ cpLang('profile.education_history') }}
              </h3>
              <div class="clear-both" />
            </div>
            <div v-for="edu in educations" :key="edu.id" class="row exp">
              <div class="col-xl-3 col-md-3 col-xs-12">
                {{ edu.achievedin }}
              </div>
              <div class="col-xl-9 col-md-9 col-xs-12">
                <div class="row">
                  <div class="col-xl-5 col-xs-12 px-sm-0">
                    <b>{{ edu.educationleveldesc }}</b>
                    <div class="pb-1">
                    {{ edu.institutename }}
                  </div>
                  </div>
                  <div v-if="edu.major" class="col-xl-7 col-xs-12">
                    <b>{{ cpLang('profile.major') }}:</b> {{ edu.major }}
                  </div>
                  <div v-else class="col-xl-7 col-xs-12">
                    <b>{{ cpLang('profile.major') }}:</b> {{ edu.studyfielddesc }}
                  </div>
                  <div v-show="edu.gpa !== ''" class="col-12 p-sm-0">
                    <b>GPA: </b>{{ edu.gpa }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end edu -->
          <!-- edu -->
          <div class="card profile-card edu-card-wrap">
            <div class="d-inline">
              <h3 class="d-inline-block">
                {{ cpLang('profile.license_title') }}
              </h3>
              <div class="clear-both" />
            </div>
            <div v-for="(license,idx) in licenses" :key="`${license.id}-${idx}`" class="row exp">
              <div class="col-xl-3 col-md-3 col-xs-12">
                {{ license.startdate && license.startdate.date ? formatDate(license.startdate.date) : '' }} - {{ license.expirydate && license.expirydate.date ? formatDate(license.expirydate.date) : '' }}
              </div>
              <div class="col-xl-9 col-md-9 col-xs-12">
                <div class="row">
                  <div class="col-xl-5 col-xs-12 px-0">
                    <b>{{ license.name }}</b>
                    <div class="pb-1">
                      {{ license.organization }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end edu -->
          <!-- skills -->
          <div class="card profile-card">
            <div class="d-inline">
              <h3 class="d-inline-block">
               {{ cpLang('profile.language_skill') }}
              </h3>
              <div class="clear-both" />
            </div>
            <div class="pt-3">
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                  {{ cpLang('profile.languages') }}
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12 mb-2">
                  <div class="skeleton-item py-2 py-sm-0 large">
                    <span v-for="(lang, idx) in languages" :key="lang.id + idx" class="badge badge-light">
                      <span v-if="lang.desc">{{ lang.desc }} <b>{{ lang.level.desc }}</b></span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                  {{ cpLang('profile.other_skills') }}
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12">
                  <div class="skeleton-item py-2 py-sm-0 large">
                  <span v-for="skill in skills" :key="'skill' + skill.id" class="badge badge-light">
                    <span v-if="skill.desc">{{ skill.desc }} <b>{{ skill.level.desc }}</b></span>
                  </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end skills -->
          <!-- contact info -->
          <div class="card profile-card last">
            <div class="d-inline">
              <h3 class="d-inline-block">
                {{ cpLang('profile.contact_info') }}
              </h3>
              <div class="clear-both" />
            </div>
            <div class="pt-3">
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                  <b class="w-20">{{ cpLang('profile.tel') }}:</b>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12">
                  <span class="">{{ formatTel(contact.tel) }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                  <b class="w-40">{{ cpLang('apply.email') }}:</b>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12">
                  <span>{{ contact.email }}</span>
                </div>
              </div>
              <div v-for="(item,index) in contact.website" :key="'website-'+index" class="row">
                <div v-show="item !== ''">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                    <b class="w-40">{{ cpLang('profile.website') }}:</b>
                  </div>
                  <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12">
                    <a :href="addHttp(item)" target="_blank" class="">
                      {{ item }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-xs-12">
                  <b class="w-40">{{ cpLang('profile.social_media') }}:</b>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-xs-12">
                  <div v-if="contact.socialmedia && contact.socialmedia.facebook" class="d-block">
                  facebook.com/{{ contact.socialmedia.facebook }}
                  </div>
                  <div v-if="contact.socialmedia && contact.socialmedia.linkedin" class="d-block">
                  linkedin.com/{{ contact.socialmedia.linkedin }}
                  </div>
                  <div v-if="contact.socialmedia && contact.socialmedia.github" class="d-block">
                  github.com/{{ contact.socialmedia.github }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center footer-btn-group">
              <button @click="logging ? null : $emit('edit')" :disabled="logging" class="btn btn-primary">
                {{ cpLang("profile.edit") }}
              </button>
              <button @click="logging ? null : submit()" :disabled="logging" class="btn profile-btn border-0">
                {{ cpLang("global.submit") }}
                <i v-show="logging" class="fas fa-circle-notch fa-spin" />
              </button>
            </div>
          <!-- end contact info -->
        </div>
      </div>
      <div class="clear-both" />
    </div>
  </section>
</template>
<script>
// import ProfilePic from '@/components/profile/ProfilePic'
import ProfileSummary from '@/components/profile/ProfileSummary'
import commonFunc from '~/assets/js/commonHelper.js'

export default {
  components: {
    // ProfilePic,
    ProfileSummary
  },
  data: function () {
    return {
      member: [],
      languages: [],
      skills: [],
      experiences: [],
      educations: [],
      licenses: [],
      contact: [],
      contact_num: '',
      expectation: [],
      selectedTemplate: 'A',
      showExport: false,
      // for passobj to component
      passLocation: [],
      passJoblevel: [],
      passEmploymenttype: [],
      passJobfunction: [],
      passIndustry: [],
      passEduLvList: [],
      passMajor: [],
      passLanguages: [],
      passProficiencies: [],
      passSkills: [],
      passVisibility: [
        { id: 1, desc: this.cpLang('profile.vis_searchable') },
        { id: 2, desc: this.cpLang('profile.vis_private') },
        { id: 3, desc: this.cpLang('profile.vis_anonymous') }
      ],
      //
      expObj: null,
      eduObj: null,
      skillObj: null,
      memberObj: null,
      summaryObj: {},
      showEditButton: false,
      logging: false
    }
  },
  computed: {
    lastupdate: function() {
      return this.$auth.user.statistics.lastupdate
    },
    photoUrl: function () {
      return this.$auth.user.image ? this.$auth.user.image : '/asset/image/photo/avatar.jpg'
    }
  },
  beforeMount() {
    const top = document.getElementById('__layout')
    if (top) {
      top.classList.remove('show-panel')
    }
  },
  async mounted() {
    const event = new Event('isProfilePage')
    window.dispatchEvent(event)
    const vm = this
    this.getExpertise()
    this.getExperiences()
    this.getEducations()
    this.getContact()
    this.getExpectation()
    this.getMember()
    this.getLicenses()
    // highlight anchor
    if (window.location.hash && document.querySelector(window.location.hash) !== undefined) {
      const el = document.querySelector(window.location.hash)
      this.$nextTick(() => {
        el.classList.add('active')
      })
      document.addEventListener('mousedown', function(e) {
        document.querySelectorAll('.profile-card.active').forEach((el) => {
          el.classList.remove('active')
        })
      })
    }
    await this.$axios.get('locations').then(function(response) {
      vm.passLocation = response.data.locations
    })
    await this.$axios.get('studyfields').then(function(response) {
      vm.passMajor = response.data.studyfields
    })
    await this.$axios.get('positions?extrafield=property').then(function(response) {
      vm.passJoblevel = response.data.joblevel
      vm.passEmploymenttype = response.data.employmenttype.slice(0, 5)
      vm.passIndustry = response.data.industry
      vm.passEduLvList = response.data.education
      vm.passJobfunction = response.data.jobfunction
    })
    await this.$axios.get('skillexperiences').then(function(response) {
      response.data.skillexperiences.forEach(function (item) {
        vm.passSkills.push({ id: item.id, desc: item.skillexperiencedesc })
      })
    })
    await this.$axios.get('languages').then(function(response) {
      response.data.languages.forEach(function(item, index) {
        vm.passLanguages.push({ id: item.id, desc: item.languagedesc })
      })
      vm.passProficiencies = response.data.proficiencies
    })
    this.showEditButton = true
  },
  methods: {
    submit: function() {
      this.logging = true
      this.$emit('submit')
    },
    checkEmpty: function(str) {
      return commonFunc.checkStrEmpty(str)
    },
    validObj: function(obj, k) {
      return commonFunc.validObj(obj, k)
    },
    formatTel: function(e) {
      if (e) {
        if (e.indexOf('-0') > -1) {
          return e.replace('-0', '')
        }
        if (e.substr(0, 1) === '-') {
          return e.replace('-', '')
        }
        return e
      }
    },
    displayAchievement: function (exp) {
      if (!exp || exp.achievement === undefined || exp.achievement === null) {
        return ''
      }
      return exp.achievement.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    displayRoles: function (exp) {
      if (!exp || exp.roles === undefined || exp.roles === null) {
        return ''
      }
      return exp.roles.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    addHttp: function(e) {
      if (e) {
        if (e.indexOf('https://') < 0) {
          return `http://${e}`
        }
        return e
      }
      return ''
    },
    formatDate: function(date) {
      const date2 = new Date(date.replace(/\s/g, 'T'))
      // const m = date2.getUTCMonth() + 1
      const monthNames = [
        this.cpLang('recruitmentday.jan_short'),
        this.cpLang('recruitmentday.feb_short'),
        this.cpLang('recruitmentday.mar_short'),
        this.cpLang('recruitmentday.apr_short'),
        this.cpLang('recruitmentday.may_short'),
        this.cpLang('recruitmentday.jun_short'),
        this.cpLang('recruitmentday.jul_short'),
        this.cpLang('recruitmentday.aug_short'),
        this.cpLang('recruitmentday.sep_short'),
        this.cpLang('recruitmentday.oct_short'),
        this.cpLang('recruitmentday.nov_short'),
        this.cpLang('recruitmentday.dec_short')
      ]
      return monthNames[date2.getUTCMonth()] + ' ' + date2.getFullYear()
    },
    getExpertise: async function () {
      const vm = this
      await this.$axios.get('member/profile/expertise').then(function(response) {
        vm.languages = response.data.languages
        vm.skills = response.data.skills
      })
    },
    getExperiences: async function () {
      const vm = this
      await this.$axios.get('member/profile/experiences').then(function(response) {
        vm.experiences = response.data.experiences
      })
    },
    getEducations: async function () {
      const vm = this
      await this.$axios.get('member/profile/educations').then(function(response) {
        vm.educations = response.data.educations
      })
    },
    getContact: async function () {
      const vm = this
      await this.$axios.get('member/profile/contact').then(function(response) {
        vm.contact = response.data
      })
    },
    getLicenses: async function () {
      const vm = this
      await this.$axios.get('member/profile/licenses').then(function(response) {
        vm.licenses = response.data.licenses
      })
    },
    getMember: async function() {
      const vm = this
      await this.$axios.get('/member/').then(function(res) {
        vm.summaryObj.summary = res.data.summary
        vm.summaryObj.overview = res.data.careerobjective
        vm.summaryObj.birthdate = res.data.birthdate
      })
    },
    getExpectation: async function () {
      const vm = this
      await this.$axios.get('member/profile/expectation').then(function(response) {
        vm.expectation = response.data
      })
    }
  }
}
</script>
<style lang="scss">
.section-temp{
  .myprofile{
    position: relative;
  }
  .col-12{
    &.mt-1{
      border-radius: 20px;
      box-shadow: 0px 3px 6px #00000029;
    }
  }
  .editing-heading{
    padding: 20px 0;
    font-size: 16px;
  }
  .preview-avator{
    border-radius: 50%;
  }
  .icon-wrap{
    width: 80px;
    height: 80px;
    margin: 10px 40px 10px auto;
  }
  .profile-card{
    margin-bottom: 0 !important;
    border-radius: 0 !important;
    box-shadow: unset !important;
    padding: 30px !important;
    &.first{
      position: relative;
      border-radius: 20px 20px 0 0 !important;
      &:before{
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 80px;
        background: url(/asset/image/photo/cv_top_bg.png) transparent no-repeat;
        background-size: contain;
        border-radius: 20px;
        background-position: 0px 0px;
      }
    }
    &.last{
      border-radius: 0px 0px 20px 20px !important;
      position: relative;
    }
    &::after{
      content: '';
      position: absolute;
      bottom: 0;
      width: 93%;
      height: 2px;
      background: #ccc;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .footer-btn-group{
    margin: 31px auto 50px;
    button{
      position: relative;
      z-index: 10;
    }
    .profile-btn{
      padding: 6px 20px;
      margin-left: 15px;
    }
    &:after{
      content: '';
      position: absolute;
      bottom: 0px;
      right: 0;
      width: 100%;
      height: 80px;
      background: url(/asset/image/photo/cv_top_bottom.png) transparent no-repeat;
      background-size: cover;
      border-radius: 20px;
      background-position: 0px -7px;
    }
  }
  @media screen and (max-width: 578px) {
    .profile-card{
      padding: 15px !important;
    }
  }
}

</style>
